import { Component, OnInit, NgZone } from "@angular/core";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

import { MainService } from "../../services/main.service";
import { AccountsList } from "../../model/interface.model";
import { AccountService } from "../../services/account.service";
import { environment } from "../../../../environments/environment";
am4core.useTheme(am4themes_animated);

@Component({
  selector: "app-index",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.css"],
})
export class IndexComponent implements OnInit {
  liveAccounts: AccountsList[] = null;
  demoAccounts: AccountsList[] = null;
  tab: number = 2;

  platformWindows: string = "#";
  platformAndroid: string = "#";
  platformIos: string = "#";
  huawei: string = "#";

  private chart: am4charts.PieChart;
  constructor(
    private main: MainService,
    private zone: NgZone,
    private account: AccountService
  ) {}

  ngOnInit() {
    this.platformWindows = environment.windows_platform;
    this.platformAndroid = environment.android_platform;
    this.platformIos = environment.ios_platform;
    this.huawei = environment.huawei;

    this.getDemoAccounts();
  }

  ngAfterViewInit() {
    this.getLiveAccounts();
  }

  createAccountFundChart(balance: number, deposit: number, withdraw: number) {
    this.zone.runOutsideAngular(() => {
      let chart = am4core.create("AccountFundsChart", am4charts.PieChart);

      let data = [
        {
          funds: "Balance",
          litres: balance,
          color: am4core.color("#e74c3c"),
        },
        {
          funds: "Deposit",
          litres: deposit,
          color: am4core.color("#2ecc71"),
        },
        {
          funds: "Withdraw",
          litres: withdraw,
          color: am4core.color("#3498db"),
        },
      ];
      chart.data = data;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "litres";
      pieSeries.dataFields.category = "funds";
      pieSeries.dataFields.hidden = "hidden";

      chart.innerRadius = am4core.percent(50);

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      pieSeries.slices.template.tooltipText = "";
      pieSeries.slices.template.propertyFields.fill = "color";

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
      chart.legend.valueLabels.template.text = "{value.value} USD";

      this.chart = chart;
    });
  }

  ngOnDestroy() {
    this.zone.runOutsideAngular(() => {
      if (this.chart) {
        this.chart.dispose();
      }
    });
  }

  getAccountsFunds() {
    this.main.getAccountFunds().subscribe((response) => {
      if (response.request_status) {
        this.createAccountFundChart(
          response.data.balance,
          response.data.deposit,
          response.data.withdraw
        );
      }
    });
  }

  getLiveAccounts() {
    this.account.getLiveAccounts().subscribe((response) => {
      this.liveAccounts = response.data;
      this.getAccountsFunds();
    });
  }

  getDemoAccounts() {
    this.account.getDemoAccounts().subscribe((response) => {
      this.demoAccounts = response.data;
    });
  }

  selectTab(tab: number) {
    this.tab = tab;
  }
}
